<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ap_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="ap_date">
            <label class="weui-form-preview__label">{{
              customLabel.ap_date || "单据日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ap_date
            }}</span>
          </div>

          <custom-field :readOnly="true" :label="customLabel.ap_text1 || '自定义字段1'"
          v-model="form.main.ap_text1" slot="ap_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ap_text2 || '自定义字段2'"
          v-model="form.main.ap_text2" slot="ap_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ap_text3 || '自定义字段3'"
          v-model="form.main.ap_text3" slot="ap_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ap_text4 || '自定义字段4'"
          v-model="form.main.ap_text4" slot="ap_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ap_text5 || '自定义字段5'"
          v-model="form.main.ap_text5" slot="ap_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ad_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "产品名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_orispeccode"
              v-if="item.productDTO.pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.productDTO.pr_spec"
              slot="pr_spec"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_brand"
              v-if="item.productDTO.pr_brand"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_brand || "厂家/品牌"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_brand
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_zxbzs"
              v-if="item.productDTO.pr_zxbzs"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_zxbzs || "最小包装数"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_zxbzs
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ad_qty">
              <label class="weui-form-preview__label">{{
                customLabel.ad_qty || "数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.ad_qty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              slot="ad_yqty"
            >
              <label class="weui-form-preview__label">{{
                customLabel.ad_yqty || "已转采购"
              }}</label>
              <div class="weui-form-preview__value">
                <span>{{ item.ad_yqty }} {{ item.productDTO.pr_unit }}</span>
                <span class="ml text-link" v-if="!editable&&(!item.ad_yqty||item.ad_yqty<item.ad_qty)" @click="turnOrder(item)">转采购</span>
              </div>
            </div>
            <div class="weui-form-preview__item" slot="ad_delivery">
              <label class="weui-form-preview__label">{{
                customLabel.ad_delivery || "需求日期"
              }}</label>
              <span class="weui-form-preview__value">{{
                dateFormat(item.ad_delivery,'yyyy-MM-dd')
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.ad_remark"
              slot="ad_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.ad_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.ad_remark }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ad_text1 || '自定义字段1'"
            v-model="item.ad_text1" slot="ad_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ad_text2 || '自定义字段2'"
            v-model="item.ad_text2" slot="ad_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ad_text3 || '自定义字段3'"
            v-model="item.ad_text3" slot="ad_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ad_text4 || '自定义字段4'"
            v-model="item.ad_text4" slot="ad_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ad_text5 || '自定义字段5'"
            v-model="item.ad_text5" slot="ad_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.ap_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/purchase/apply_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/purchase/application",
      codeField: "ap_code",
      statusField: "ap_statuscode",
      caller: "Application",
      xtype: "purchase-application-formpanel",
    };
  },
  methods: {
    turnOrder(item) {
      this.$router.push({
        name: 'PurchaseApplyToOrder',
        params: {
          source: item
        }
      })
    }
  }
};
</script>